import Checkmate from "./Components/Checkmate";
import Delicacies from "./Components/Delicacies";
import Headlines from "./Components/Headlines";
import Home from "./Components/Home";
import Navbar from "./Components/Navbar";



function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <Headlines />
      <Delicacies />
      <Checkmate />
    </div>
  );
}

export default App;
